import React, { useEffect } from "react";
import useState from 'react-usestateref';
import {
  //fetchToken,
  fetchListConnections,
  readEachConnection,
  buildBinary,
  readTextFile,
} from "../authorization/FetchToken";
import Navbar from "../components/Navbar";
import { Typography } from "@mui/material";
import Swal from 'sweetalert2';
import { useAuth } from './AuthContext';
import { Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoTip from "../components/InfoTip";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import Drawer from "@mui/material/Drawer";
import { IconButton,Alert} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Spinner from '../Spinner';

const ManageLicense = () => {
  const [builds, setBuilds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [version, setVersion, versionRef] = useState("");
  const [feature, setFeature, featureRef] = useState("");
  const [includeSuperset, setIncludeSuperset] = useState(false);
  const [selectedBuild, setSelectedBuild] = useState(null);
  //const [issuedOption, setIssuedOption] = useState("now");
  const [licenseStart, setLicenseStart] = useState("now");
  const [licenseEnd, setLicenseEnd] = useState("");
  const { userSessionRef} = useAuth();
  const [loggedInUserRole,setloggedInUserRole] = useState("")
  const [openDoc, setOpenDoc] = useState(false);
  const [doc, setDoc] = useState("");
  const [success, setSuccess] = useState("");

  const fetchBuilds = async () => {
    try {
      setLoading(true)
      setloggedInUserRole(userSessionRef.current["role"])
      const resp = await fetchListConnections("builds", "dirs",userSessionRef.current["orgName"]);
      console.log("fetchBuilds::1", resp);
      let  buildFolders = [];

      // Filter out `.zip` entries
      if (resp) {
      buildFolders = resp.filter((b) => !b.endsWith(".zip") && !b.includes("license"));
      }

      const buildDetails = [];
      console.log("buildFolders::1", buildFolders);
      for (const build of buildFolders) {
        console.log("buildFolders::11", build);
        try {
          // --- 1. Read license/license.json ---
          let issued_at = "";
          let expires_at = "";
          let feature = "";
          try {
            const licenseData = await readEachConnection(
              "builds",
              `${build}/license/license.json`,
              userSessionRef.current["orgName"]
            );
            issued_at = licenseData.issued_at || "";
            expires_at = licenseData.expires_at || "";
          } catch (e) {
            console.log(`⚠ No license.json found in ${build}`);
          }

          // --- 2. List files under config/ ---
          let configs = [];
          try {
            const configFiles = await fetchListConnections(
              `builds/${build}/config`,
              "dirs",
              userSessionRef.current["orgName"]
            );
            configs = configFiles || [];
            const versionDetails = await readTextFile(
              userSessionRef.current["orgName"],
              `${process.env.REACT_APP_ARCHITECTURE_NAME}`,
              "builds",
              `${build}/.version`,
              "",
            );
            //configs = configFiles.map(e => e.split("/")[1]) || [];
            feature = versionDetails["feature"] || "";
            console.log("config file::11", configFiles);
          } catch (e) {
            console.log(`⚠ No config folder in ${build}`);
          }
          console.log("config file::2", configs[0]);

          buildDetails.push({
            build,
            feature,
            issued_at,
            expires_at,
            configs,
          });
          console.log("buildDetails::1", JSON.stringify(buildDetails));
        } catch (err) {
          console.error("Error reading build:", build, err);
        }
      }
      setBuilds(buildDetails);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

const handleRefresh = async () => {
    setLoading(true);
    try {
      await fetchBuilds(); // ⬅️ wait for API
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userSessionRef) return;
    fetchBuilds();
  }, [userSessionRef]);

  const handleBuild = async () => {
    let licenseStartValue = "";
    try {

     if (licenseStart === "now") {
        // Current UTC time rounded to minutes
        const now = new Date();
        licenseStartValue = now.toISOString().slice(0, 16) + ":00Z";
      
        console.log("License Start (UTC now):", licenseStartValue);
      } else {
        let value = licenseStart.trim();
      
        // User entered YYYY-MM-DDTHH:MM
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) {
          value += ":00Z";
        }
        // Already in RFC3339 format YYYY-MM-DDTHH:MM:SSZ
        else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(value)) {
          // leave unchanged
        }
        // Invalid format
        else {
          setError(
            "⚠ Invalid date format. Use YYYY-MM-DDTHH:MM or YYYY-MM-DDTHH:MM:SSZ"
          );
          return;
        }
      
        licenseStartValue = value;
        console.log("License Start (custom):", licenseStartValue);
      }

      console.log("License Start Value:11", licenseStartValue);

      const resp = await buildBinary(
        version,
        feature,
        includeSuperset,
        licenseStartValue,
        licenseEnd,
        userSessionRef.current["orgName"]
      );
      console.log("Build Resp::1", resp);

      fetchBuilds();
      setSuccess(`Successfully built version ${version} binary. Download it from builds section in Files page.`)

    } catch (err) {
      console.error("Build failed", err);
      setError(`Build failed: ${err.message}`);
      // optionally show a failure message
    }
  };

  const handleSelectBuild = (build) => {
    setSelectedBuild(build);
    // Extract version automatically
    if (build.build) {
      //const parts = build.build.split("_");
      //setVersion(parts[parts.length - 1]);
      setVersion(build.build);
      setFeature(build.feature);
    }
  };

  //if (loading) return <p style={{ marginLeft: "20px" }}>Loading builds...</p>;
  //if (error) return <p style={{ color: "red" }}>⚠ {error}</p>;

  return (
    <div>
    
      <div style={{ padding: "5rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px",marginBottom: '1rem',}}>

            {/* SNACKBAR SUCCESS */}
      <Snackbar
        open={!!success}
        autoHideDuration={30000}
        onClose={() => setSuccess("")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setSuccess("")} severity="success">
          {success}
        </Alert>
      </Snackbar>
      {loading && (
        <div className="overlay">
          <div className="loading-container">
            <Spinner />
            <p className="please-wait">Please wait...</p>
          </div>
        </div>
      )}

      {/* SNACKBAR ERROR */}
      <Snackbar
        open={!!error}
        autoHideDuration={30000}
        onClose={() => setError("")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setError("")} severity="error">
          {error}
        </Alert>
      </Snackbar>


        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#0a2540",
            fontFamily: "'Inter', 'Segoe UI', sans-serif",
            letterSpacing: "0.3px",
          }}
        >
          Builds
        </Typography>
        <InfoTip
        keyword="build_management"
        onLoad={(text) => {
          setDoc(text);
          setOpenDoc(true);
        }}
        />
        </div>

        <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px",
  }}
>
  <Button
    variant="contained"
    startIcon={<RefreshIcon />}
    onClick={handleRefresh}
    sx={{
      textTransform: "none",
      fontSize: "13px",
      borderRadius: "6px",
      px: 1.5,
      py: 0.75,
      backgroundColor: "#2563eb",
      "&:hover": {
        backgroundColor: "#1d4ed8",
      },
    }}
  >
    {loading ? (
          <>
            <span className="spinner" />  Refresh...
          </>
        ) : (
          ' Refresh List'
        )}  
   
  </Button>
</div>

        {/* Builds Table */}
        {builds.length === 0 ? (
          <p>No builds found.</p>
        ) : (
          <table
            border="1"
            cellPadding="8"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              marginBottom: "24px",
              fontSize: "14px",
            }}
          >
            <thead
              style={{
                backgroundColor: "#e0e7ff", // soft blue background
                textAlign: "left",
              }}
            >
              <tr>
                {[
                  "Build Name",
                  "Feature",
                  "Issued At",
                  "Expires At",
                  "Config Files",
                ].map((header) => (
                  <th
                    key={header}
                    style={{
                      color: "#1d4ed8", // your preferred blue
                      fontWeight: 800,
                      fontSize: "0.95rem",
                      padding: "12px 16px",
                      borderBottom: "2px solid #1d4ed8", // subtle blue underline
                      fontFamily: "'Inter', system-ui, sans-serif",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {builds.map((lic, idx) => (
                <tr
                  key={idx}
                  onClick={() => handleSelectBuild(lic)}
                  style={{
                    backgroundColor:
                      selectedBuild?.build === lic.build ? "#dff0d8" : "white",
                    cursor: "pointer",
                  }}
                >
                  <td>{lic.build}</td>
                  <td>{lic.feature}</td>
                  <td>{lic.issued_at}</td>
                  <td>{lic.expires_at}</td>
                  <td>
                    {lic.configs?.length > 0 ? (
                      <ul style={{ margin: 0, paddingLeft: "20px" }}>
                        {lic.configs.map((f, i) => (
                          <li key={i}>{f}</li>
                        ))}
                      </ul>
                    ) : (
                      <i>No configs</i>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* First Row: Version + Build Button */}

        {/* Superset Checkbox - separate line */}
        <div
          style={{
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              checked={includeSuperset}
              onChange={(e) => setIncludeSuperset(e.target.checked)}
              disabled={
                !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
              }
            />
            Enable Superset
          </label>
        </div>

        {/* License Section - separate line */}
        <div
          style={{
            display: "flex",
            flexDirection: "column", // 👈 stack License Start & Duration vertically
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          {/* License Start */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label style={{ fontWeight: "500" }}>License Start:</label>
            <label
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
              <input
                type="checkbox"
                checked={licenseStart === "now"}
                onChange={(e) => setLicenseStart(e.target.checked ? "now" : "")}
              />
              Use Now
            </label>
            {licenseStart !== "now" && (
  <div>
    <input
      type="text"
      value={licenseStart}
      onChange={(e) => setLicenseStart(e.target.value)}
      style={{
        padding: "6px 8px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        fontSize: "14px",
      }}
    />
    <div
      style={{
        fontSize: "12px",
        color: "#666",
        marginTop: "4px",
      }}
    >
      Format: YYYY-MM-DDTHH:MM
    </div>
  </div>
)}


          </div>

          {/* License Duration */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  <label style={{ fontWeight: "500" }}>Duration:</label>

  {["Monthly", "3 Months", "6 Months", "Yearly"].map((option) => {
    const isTrial = userSessionRef.current["paymentStatus"] === "TRIAL";
    const isAllowedRole =
      loggedInUserRole === "ROOT" || loggedInUserRole === "admin";
    console.log("isAllowedRole::1",isAllowedRole,isTrial,loggedInUserRole,userSessionRef.current)
    const isDisabled =
      !isAllowedRole || (isTrial && option !== "Monthly");

    return (
      <label
        key={option}
        style={{
          marginRight: "10px",
          color: isDisabled ? "#9ca3af" : "inherit", // 🔥 grey text
        }}
      >
        <input
          type="radio"
          name="license"
          value={option}
          onChange={(e) => setLicenseEnd(option)}
          disabled={isDisabled}
        />
        {option}
      </label>
    );
  })}
</div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "16px",
              padding: "12px 0",
              borderBottom: "1px solid #ddd",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline", // aligns elements along the midline
                gap: "12px", // space between elements
                flexWrap: "wrap", // wraps on smaller screens
              }}
            >
              <label
                htmlFor="versionInput"
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "32px", // match input/button height
                  whiteSpace: "nowrap",
                }}
              >
                Version:
              </label>
              <input
                type="text"
                id="versionInput"
                placeholder="Enter custom version"
                value={version}
                onChange={(e) => setVersion(e.target.value)}
                style={{
                  height: "36px", // match lineHeight
                  padding: "0 8px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "14px",
                  minWidth: "160px",
                  boxSizing: "border-box",
                }}
              />

              <button
                onClick={() => {

                  Swal.fire({
                    title: 'Confirm Build',
                    text: `Are you sure you want to build ${version}? This will generate a new licensed binary and may affect usage limits or billing.`,
                    icon: 'warning',
                    background: '#ccc',
                    color: '#000',
                    iconColor: '#d32f2f',
                    confirmButtonText: 'Build',
                    confirmButtonColor: '#d32f2f',
                    cancelButtonText: 'Cancel',
                    cancelButtonColor: '#f5c518',
                    showCancelButton: true,
                  }).then((result) => {
                    if (result.isConfirmed)
                      handleBuild();
                  });
                }}

                disabled={
                  !(loggedInUserRole === "ROOT" || loggedInUserRole === "admin")
                }
                style={{
                  height: "32px",
                  backgroundColor: !(
                    loggedInUserRole === "ROOT" || loggedInUserRole === "admin"
                  )
                    ? "#ccc"
                    : "#2563eb",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  padding: "8px 16px",
                  fontSize: "14px",
                  cursor: !(
                    loggedInUserRole === "ROOT" || loggedInUserRole === "admin"
                  )
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                {loading ? "Building..." : "Build"}
              </button>

              <Typography
              variant="caption"
              sx={{
                fontSize: "11px",
                fontWeight: 400,
                color: "#6b7280",
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
                marginTop: "6px",
                lineHeight: 1.3,
              }}
            >
              **By proceeding, you agree to the {" "}
              <a
                href="/terms"
                style={{
                  color: "#2563eb",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                Terms of Service
              </a>.
            </Typography>            
            </div>

          </div>
        </div>
      </div>

  <Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
  >

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
    >
  <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
  >
  {doc}
  </ReactMarkdown>
    </div>

  </div>

</Drawer>

    </div>
  );
};

export default ManageLicense;
